// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"e14e327f","453":"5e2ba05c","455":"d2e9083a","977":"db9977f2"}[chunkId] + ".chunk.js";
};